import type { IAdapter } from '../event-client';
import type { EventPayloads, EventTypes, LoginPayload } from '../events';

const SHORTIO_CLID_KEY = 'shortio_clid';

const subscribedEvents: Array<EventTypes> = ['purchase'];

//Testing change
class Transformer {
	static transformPurchaseEvent(_data: EventPayloads['purchase']): void {
		const clid = sessionStorage.getItem(SHORTIO_CLID_KEY);
		if (!clid) return;

		const conversionURL = `https://go.laam.pk/.shortio/conversion?c=purchase&clid=${clid}`;

		if (typeof navigator !== 'undefined') {
			navigator.sendBeacon(conversionURL);
		}
	}
}

export class ShortioAdapter implements IAdapter {
	name = 'shortio';

	async init(): Promise<void> {
		// Capture clid as soon as the adapter is initialized
		this.captureClid();
	}

	private captureClid() {
		if (typeof window !== 'undefined') {
			const urlParams = new URLSearchParams(window.location.search);
			const clid = urlParams.get('clid');

			if (clid) {
				sessionStorage.setItem(SHORTIO_CLID_KEY, clid);
			}
		}
	}

	sendEvent<T extends EventTypes>(eventName: T, data: EventPayloads[T]): void {
		if (!subscribedEvents.includes(eventName)) {
			return;
		}

		if (eventName === 'purchase') {
			Transformer.transformPurchaseEvent(data as EventPayloads['purchase']);
		}
	}

	login(_data: LoginPayload): void {
		// No login needed
	}

	logout(): void {
		// No logout needed
	}
}
